import { render, staticRenderFns } from "./WageList.vue?vue&type=template&id=3613b681&scoped=true&"
import script from "./WageList.vue?vue&type=script&lang=js&"
export * from "./WageList.vue?vue&type=script&lang=js&"
import style0 from "./WageList.vue?vue&type=style&index=0&id=3613b681&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613b681",
  null
  
)

export default component.exports